import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Catalog } from './components/Catalog';
import { Recommended } from './components/Recommended';
import { Categories } from './components/Categories';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-gradient-to-b from-gray-50 to-white text-slate-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Recommended data-id="element-4" />
        <Catalog data-id="element-5" />
        <Categories data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}